/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Scope_LockInputs */

const en_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope lock`)
};

const ar_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تثبيت النطاق`)
};

const bn_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোপ লক`)
};

const de_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope-Lock`)
};

const es_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcance cerrado`)
};

const fr_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Périmètre verrouillé`)
};

const pt_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Âmbito fechado`)
};

const zh_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`范围锁定`)
};

const tr_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapsam kilidi`)
};

const ru_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фиксация скоупа`)
};

const pl_svchip_scope_lock = /** @type {(inputs: Svchip_Scope_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamrożony zakres`)
};

/**
* | output |
* | --- |
* | "Scope lock" |
*
* @param {Svchip_Scope_LockInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_scope_lock = /** @type {((inputs?: Svchip_Scope_LockInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Scope_LockInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_scope_lock(inputs)
	if (locale === "bn") return bn_svchip_scope_lock(inputs)
	if (locale === "de") return de_svchip_scope_lock(inputs)
	if (locale === "es") return es_svchip_scope_lock(inputs)
	if (locale === "fr") return fr_svchip_scope_lock(inputs)
	if (locale === "pt") return pt_svchip_scope_lock(inputs)
	if (locale === "zh") return zh_svchip_scope_lock(inputs)
	if (locale === "tr") return tr_svchip_scope_lock(inputs)
	if (locale === "ru") return ru_svchip_scope_lock(inputs)
	if (locale === "pl") return pl_svchip_scope_lock(inputs)
	return en_svchip_scope_lock(inputs)
});